
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { UserItemProps } from ".";
import { loading, find } from "store/user";

interface ApiUserFindByIdInputProps {
    id: number;
}

type ApiUserFindOutputProps = OutputBaseProps<{ item: UserItemProps; }, ApiUserFindByIdInputProps>

export const apiUserFindById = async (data: ApiUserFindByIdInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiUserFindOutputProps>(`/api/user/${data.id}`))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
    }
    return res;
};